import React, { ReactNode } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { TPedidoHistorico } from 'src/components/projetos/types';
import theme from 'src/theme/light';
import {ChangeStatePedido } from 'src/components/projetos/historico/Historico';
import { useObservable } from 'src/framework/store/storeUtil';
import { componentes$ } from 'src/store/global.store';
import { PermissionUtil } from 'src/framework/commons/PermissionUtil';
import { formatData } from '../utils/actions';
import { Pedido } from 'src/components/vendas/types';
import { Formater, TypeRecords } from 'src/framework/commons/Formater';

interface ComparisonTableProps {
  dados: TPedidoHistorico[];
  changeState: ChangeStatePedido;
  pedido?: Pedido | any;
}

const styles = makeStyles({
  titulo: {
      fontWeight: "bold",
      border: '1px solid grey'
  },
  alterado: {
      backgroundColor: "#BBE6C9",
      border: '1px solid grey'
  },
  removido: {
      backgroundColor: theme.palette.error.light,
  },
  adicionado: {
      backgroundColor: theme.palette.primary.light,
  },
  header: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontWeight: "bold",
  },
  historico_selecionado: {
      backgroundColor: theme.palette.grey[200],
      border: '1px solid grey'
  },
  icon_alterou : {
      color: theme.palette.warning.main,
      fontSize: "14px"
  },
});

const TabelaComparacaoPedidos: React.FC<ComparisonTableProps> = (props) => {
  const classes = styles();
  const componentes = useObservable(componentes$);
  const permissoes = PermissionUtil.getPermissions();

  const maskDate = (date: string | Date, datetime: boolean)=>{
    if(date){
        const data = new Date(date);

        if (datetime){
            const formattedData = data.toLocaleString('pt-BR', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            });
            return formattedData;
        }else{
            const formattedData = data.toLocaleString('pt-BR', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
            });
            return formattedData;
        }    
    }else return "-";
}
  const compareRow = ((campo: string, pedidos: any, changed: boolean): ReactNode =>{
    switch(campo){
      case "pedido_erp":
        return(<>
          {pedidos.map((_historico: any)=>{
            const { pedido } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{pedido?.pedido_erp || "-"}</TableCell>)
          })}
        </>);
      case "data_emissao":
        return(<>
          {pedidos.map((_historico: any)=>{
            const { pedido } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{formatData(pedido?.data_emissao) || "-"}</TableCell>)
          })}
        </>);
      case "valor_total":
        return(<>
          {pedidos.map((_historico: any)=>{
            const { pedido } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString(pedido?.valor_pedido - (pedido?.valor_desconto || 0), TypeRecords.CURRENCY)}</TableCell>)
          })}
        </>);
      case "transportadora":
        return(<>
          {pedidos.map((_historico: any)=>{
            const { pedido } = _historico;
            const transportadora = pedido?.transportadora === 0 ? "0" : pedido?.transportadora;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{transportadora || "-"}</TableCell>)
          })}
        </>);      
      case "nome_transportadora":
        return(<>
          {pedidos.map((_historico: any)=>{
            const { pedido } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{pedido?.nome_transportadora || "-"}</TableCell>)
          })}
        </>);
      case "situacao":
        return(<>
          {pedidos.map((_historico: any)=>{
            const { pedido } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{pedido?.situacao || "-"}</TableCell>)
          })}
        </>);
      case "situacao_avaliacao":
        return(<>
          {pedidos.map((_historico: any)=>{
            const { pedido } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{pedido?.situacao_avaliacao || "-"}</TableCell>)
          })}
        </>);
      case "itens":
        return(<>
          {pedidos.map((_historico: any)=>{
            let bodyComponentes: ReactNode | null = null;
            let tableComponentes: ReactNode | null = null;
            let bodyItensNf: ReactNode | null = null;
            let bodyItensPedido: ReactNode | null = null;
            const { pedido } = _historico;
            const pedidoAtual =  props.pedido;
            if (pedido?.componentes/* && projeto?.tipo === "dimensionado"*/){
              const _componentes = pedido?.componentes?.filter((i:any) =>i.quantidade > 0);
              bodyComponentes = [_componentes.map((comp: any)=>{
                const _componente = componentes?.data?.find((c: any) => c?.id === comp?.componente_id);
                return(<TableRow key={comp?.componente_id}>
                  {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE,permissoes)&&(<TableCell>{comp?.componente_id}</TableCell>)}
                  <TableCell align="left">{_componente?.modelo}</TableCell>
                  <TableCell align="left">{comp?.quantidade}</TableCell>
                </TableRow>
                )
              }),
              ]
            }
            if(pedido?.nota_fiscal?.itens){
              const _itensNf = pedido?.nota_fiscal?.itens || [];
              bodyItensNf = _itensNf.map((itm:any)=>{
                return(<TableRow key={Number(itm?.codigo)}>
                  {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE,permissoes)&&(<TableCell><strong>{itm?.codigo}</strong></TableCell>)}
                  <TableCell align="left"><strong>{itm?.nome}</strong></TableCell>
                  <TableCell align="left"><strong>{itm?.quantidade}</strong></TableCell>
                </TableRow>)
              })
            }
            if(pedidoAtual?.dados_migracao?.Itens){
              const _itensNf = pedido?.notas_fiscais?.itens || [];
              const _componentes = pedido?.componentes?.filter((i:any) =>i.quantidade > 0);
              const _itensPedido = pedidoAtual?.dados_migracao?.Itens?.filter((i:any) => !_componentes?.find((ii:any) => Number(i.Produto) === ii.componente_id) && !_itensNf?.find((ii:any) => Number(i.Produto) === Number(ii.codigo))) || [];
              bodyItensPedido = _itensPedido.map((itm:any)=>{
                return(<TableRow key={Number(itm?.Produto)}>
                  {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE,permissoes)&&(<TableCell><strong>{itm?.Produto}</strong></TableCell>)}
                  <TableCell align="left"><strong>{itm?.DescricaoItemPedido}</strong></TableCell>
                  <TableCell align="left"><strong>{itm?.QuantidadeEntregue}</strong></TableCell>
                </TableRow>)
              })
            }
            if(bodyComponentes){
              tableComponentes = 
              <TableContainer>
                  <Table size="small">
                      <TableHead>
                          <TableRow>
                              {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE,permissoes)&&(<TableCell style={{fontWeight: 'bold'}} align="left">Código</TableCell>)}
                              <TableCell style={{fontWeight: 'bold'}} align="left">Descrição</TableCell>
                              <TableCell style={{fontWeight: 'bold'}} align="left">Qtde.</TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {bodyComponentes}
                          {bodyItensNf}
                          {bodyItensPedido}
                      </TableBody>
                  </Table>
              </TableContainer>
            }     
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{tableComponentes || "-"}</TableCell>)
            //return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{pedido?.pedido_erp || "-"}</TableCell>)
          })}
        </>);
      default:
        return(<>
        {pedidos.map((_historico: any)=>{
          return(
            <TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.pedido?.[campo] || "-"}</TableCell>
          )
        })}</>)
    }})
  return (<>
    <TableContainer className='table-historico' sx={{ overflowX: "auto" }}>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    {props.dados.map(_historico=>{
                      return(
                        <TableCell 
                          key={_historico.id}
                          style={{fontWeight: "bold"}}
                        >
                          Pedido em: {maskDate(_historico?.data_alteracao || "", true)}
                        </TableCell>
                      )
                    })}                    
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Solução Sugerida</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.pedido_erp?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Número</TableCell>
                    {compareRow("pedido_erp", props.dados, props?.changeState?.pedido_erp?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.data_emissao?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Data Emissão</TableCell>
                    {compareRow("data_emissao", props.dados, props?.changeState?.data_emissao?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor_total?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor Total</TableCell>
                    {compareRow("valor_total", props.dados, props?.changeState?.valor_total?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.transportadora?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Transportadora</TableCell>
                    {compareRow("transportadora", props.dados, props?.changeState?.transportadora?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.nome_transportadora?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Nome Transportadora</TableCell>
                    {compareRow("nome_transportadora", props.dados, props?.changeState?.nome_transportadora?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.situacao?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Situação</TableCell>
                    {compareRow("situacao", props.dados, props?.changeState?.situacao?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.situacao_avaliacao?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Situação Avaliação</TableCell>
                    {compareRow("situacao_avaliacao", props.dados, props?.changeState?.situacao_avaliacao?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.itens?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Itens</TableCell>
                    {compareRow("itens", props.dados, props?.changeState?.itens?.hasChanged)}
                </TableRow>
            </TableBody>            
        </Table>
    </TableContainer>
  </>);
};

export default TabelaComparacaoPedidos;
